import crypto from 'crypto';
import { cspReportUri } from 'services/properties/frontend';

export const getSha256Hash = async (data: string) => {
  const hash = crypto.createHash('sha256');
  hash.update(data);
  return `sha256-${hash.digest('base64')}`;
};

const getInnerJsFromScriptTag = (scriptTag: string | undefined) => {
  if (!scriptTag) {
    return '';
  }

  const start = scriptTag.indexOf('>') + 1;
  const end = scriptTag.lastIndexOf('<');
  return scriptTag.substring(start, end);
};

export const getHashForHeaderScript = (headerHtml: string) => {
  const scriptTag = headerHtml.match(/<script.*<\/script>/g)?.[0];
  const innerJs = getInnerJsFromScriptTag(scriptTag);
  return getSha256Hash(innerJs);
};

export const getCspDirectives = (globalHeaderScriptHash: string) =>
  [
    "default-src 'self' *.yle.fi *.ylestatic.fi ping.chartbeat.net",
    `script-src 'self' 'unsafe-eval' 'unsafe-inline' *.yle.fi *.ylestatic.fi *.userreport.com *.kaltura.com www.gstatic.com '${globalHeaderScriptHash}'`,
    "connect-src 'self' *.yle.fi wss://*.yle.fi *.ylestatic.fi *.demdex.net endpoint.finnpanel.fi *.kaltura.com *.akamaized.net",
    "style-src 'self' 'unsafe-inline' *.yle.fi *.ylestatic.fi *.googleapis.com",
    "font-src 'self' data: *.yle.fi *.ylestatic.fi *.googleapis.com *.gstatic.com",
    "img-src 'self' data: yle.fi *.yle.fi *.ylestatic.fi yleisradio.d3.sc.omtrdc.net ping.chartbeat.net *.userreport.com *.kaltura.com",
    "media-src 'self' data: blob: *.akamaized.net *.kaltura.com *.akamaihd.net",
    "frame-src 'self' *.userreport.com *.yle.fi",
    'worker-src blob:',
    "object-src 'none'",
    `report-uri ${cspReportUri}`,
    `report-to ${cspReportUri}`,
  ].join('; ');
